// Theme Management

import { storage } from './storage.js';
import { STORAGE_KEYS } from './config.js';

class ThemeManager {
  constructor() {
    this.currentTheme = 'light';
  }

  init() {
    const savedTheme = storage.getItem(STORAGE_KEYS.THEME, 'light');
    this.setTheme(savedTheme, false);
  }

  toggle() {
    const newTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
    this.setTheme(newTheme);
  }

  setTheme(theme, save = true) {
    this.currentTheme = theme;
    document.documentElement.setAttribute('data-theme', theme);

    if (save) {
      storage.setItem(STORAGE_KEYS.THEME, theme);
    }

    this.updateIcons(theme);
    this.updateMetaTheme(theme);

    // Dispatch event for other components (e.g., charts)
    window.dispatchEvent(new CustomEvent('themechange', { detail: { theme } }));
  }

  updateIcons(theme) {
    const icon = theme === 'dark' ? '☀️' : '🌙';
    const label = theme === 'dark' ? 'Modalità Chiara' : 'Modalità Scura';

    const themeToggle = document.getElementById('themeToggle');
    if (themeToggle) {
      themeToggle.textContent = icon;
      themeToggle.setAttribute('aria-label', label);
    }

    const sidebarToggle = document.getElementById('sidebarThemeToggle');
    if (sidebarToggle) {
      const iconSpan = sidebarToggle.querySelector('#themeIcon');
      const labelSpan = sidebarToggle.querySelector('span:last-child');
      if (iconSpan) iconSpan.textContent = icon;
      if (labelSpan) labelSpan.textContent = label;
    }
  }

  updateMetaTheme(theme) {
    const metaTheme = document.querySelector('meta[name="theme-color"]');
    if (metaTheme) {
      metaTheme.setAttribute('content', theme === 'dark' ? '#000000' : '#007AFF');
    }
  }

  getCurrentTheme() {
    return this.currentTheme;
  }
}

export const themeManager = new ThemeManager();
